export type CategoryId = 'recyclage' | 'dechets' | 'organiques' | 'jardin' | 'lourds' | 'speciales'

export interface Category {
  id: CategoryId
  label: string
  dot: string
  chip: string
  time: string
}

export const categories: Record<CategoryId, Category> = {
  recyclage: {
    id: 'recyclage',
    label: 'Recycling — clear bags',
    dot: 'bg-[#0f766e]',
    chip: 'bg-teal-50 text-teal-800',
    time: '7 a.m.',
  },
  dechets: {
    id: 'dechets',
    label: 'Garbage',
    dot: 'bg-[#475569]',
    chip: 'bg-slate-100 text-slate-700',
    time: '7 a.m.',
  },
  organiques: {
    id: 'organiques',
    label: 'Yard waste',
    dot: 'bg-[#a16207]',
    chip: 'bg-amber-50 text-amber-800',
    time: '7 a.m.',
  },
  jardin: {
    id: 'jardin',
    label: 'Branches and brush',
    dot: 'bg-[#3f6212]',
    chip: 'bg-lime-50 text-lime-800',
    time: '7 a.m.',
  },
  lourds: {
    id: 'lourds',
    label: 'Large items',
    dot: 'bg-[#7c3aed]',
    chip: 'bg-violet-50 text-violet-800',
    time: '7 a.m.',
  },
  speciales: {
    id: 'speciales',
    label: 'Special collections',
    dot: 'bg-[#db2777]',
    chip: 'bg-pink-50 text-pink-800',
    time: '7 a.m.',
  },
}

/** Collections by ISO date (YYYY-MM-DD) for the citizen's address. */
export const collectionsByDate: Record<string, CategoryId[]> = {
  '2026-07-23': ['recyclage', 'dechets'],
  '2026-07-30': ['dechets', 'organiques'],
  '2026-08-06': ['recyclage', 'dechets'],
  '2026-08-13': ['recyclage', 'dechets', 'organiques', 'lourds'],
  '2026-08-20': ['dechets', 'organiques', 'jardin'],
  '2026-08-27': ['recyclage', 'dechets', 'jardin'],
  '2026-09-10': ['recyclage', 'dechets', 'organiques', 'jardin'],
  '2026-09-18': ['recyclage', 'dechets', 'jardin'],
  '2026-09-24': ['dechets', 'organiques'],
  '2026-10-01': ['recyclage', 'dechets', 'speciales'],
}

export const monthNames = [
  'JANUARY',
  'FEBRUARY',
  'MARCH',
  'APRIL',
  'MAY',
  'JUNE',
  'JULY',
  'AUGUST',
  'SEPTEMBER',
  'OCTOBER',
  'NOVEMBER',
  'DECEMBER',
]

export const weekdayNames = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']

export const longWeekdayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']

export const longMonthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

export function toKey(date: Date): string {
  const month = `${date.getMonth() + 1}`.padStart(2, '0')
  const day = `${date.getDate()}`.padStart(2, '0')
  return `${date.getFullYear()}-${month}-${day}`
}

export function formatLongDate(date: Date): string {
  return `${longWeekdayNames[date.getDay()]}, ${longMonthNames[date.getMonth()]} ${date.getDate()}`
}
